export class KaizenAccount
{
    kaizenAccountId!: number;
    kaizenId!: number;
    glAccountImpactAreaId!: number;
    costTypeId!: number;
    costDirectionId!: number;
    savingsMeasureId!: number;
    detailedAccountId!: number;
    operationRate!: boolean;
    taktTime!: boolean;
    totalCost!:number[];
    costPerUnit!: number;
    totalSavings!: number;
    totalVolume!: number;
    averageCPUSavings!: number;
    nextFYTotalSavings!: number;
}

export class PagedResponseKaizenAccount{
    public pageNumber!: number;
    public pageSize!:number;
    public succeeded!:boolean
    public message!:string;
    public errors!:string;
    public data!:KaizenAccount[];
}